import useApi from "../../api/useApi";
import {useContext} from "react";
import AuthContext from "../../context/AuthContext";

const useUserService = () => {

  const {api} = useApi()
  const {setUser} = useContext(AuthContext)

  const updateUserAfterSuccess = (setUser, callbackSuccess, responseData) => {
    //todo add check to see 'object_type'
    // if (responseData.object_type === 'user'){
      setUser(responseData)
    // }
    callbackSuccess(responseData)
  }

  const userShow = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user',
      response => updateUserAfterSuccess(setUser, callbackSuccess, response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userShowDashBoard = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/dashboard',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userShowDashBoard: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, modelId, data) => {
    return api(
      'post',
      'user/update',
      response => updateUserAfterSuccess(setUser, callbackSuccess, response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userUpdate: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userEmailChange = (callbackSuccess, callbackValidationErrors, modelId, data) => {
    return api(
      'post',
      'user/email/change',
      response => updateUserAfterSuccess(setUser, callbackSuccess, response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userEmailChange: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userPasswordChange = (callbackSuccess, callbackValidationErrors, modelId, data) => {
    return api(
      'post',
      'user/password/change',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userPasswordChange: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userSwitchActiveCompany = (callbackSuccess, callbackValidationErrors, activeCompanyId) => {
    return api(
      'post',
      'user/switch-active-company/' + activeCompanyId,
      response => updateUserAfterSuccess(setUser, callbackSuccess, response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userSwitchActiveCompany: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userChangeRequestsSpotMapCreationStatus = (callbackSuccess, callbackValidationErrors, spotGroupId, data) => {
    return api(
      'post',
      'admin/change-requests-spot-map-creation-status/' + spotGroupId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userChangeRequestsSpotMapCreationStatus: ${error?.message || JSON.stringify(error)}`)},
      data
    )
  }

  const userInvite = (callbackSuccess, callbackValidationErrors, modelId, data) => {
    return api(
      'post',
      'user/invite',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserService::userInvite: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  return {
    objectType: 'user',
    userShow,
    userShowDashBoard,
    userUpdate,
    userEmailChange,
    userPasswordChange,
    userSwitchActiveCompany,
    userChangeRequestsSpotMapCreationStatus,
    userInvite,
  }
}
export default useUserService
